exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report-body[data-v-9a3f0d76]{background:#f0f0f0;max-width:100%;min-height:100vh}.v-card-title[data-v-9a3f0d76]{background-color:#f8f9fa;border-bottom:1px solid #dee2e6}.text-h4[data-v-9a3f0d76]{font-weight:600}.text-subtitle-1[data-v-9a3f0d76]{color:#6c757d;font-weight:500}", ""]);

// exports
